import styled from 'styled-components'

export const ErrorMessage = styled.div`
    color: red;
    text-align: center;
`